// Pure derive for the A1 first-run guided checklist.
// Given LifeOsState + todayIso string, computes the 3 onboarding step done-flags.
// No side effects. All inputs come from immutable state slices.
import type { LifeOsState } from "../types";

export type GettingStartedStep = {
  id: "add-task" | "add-goal" | "morning-plan";
  label: string;
  done: boolean;
  /** Which UI action opens when the user taps this undone step. */
  actionKind: "task" | "goal" | "morning-plan";
};

/**
 * Derive the 3 getting-started steps.
 *
 * Step 1 — "Ghi việc đầu tiên": tasks collection non-empty.
 * Step 2 — "Tạo mục tiêu":       goals collection non-empty.
 * Step 3 — "Lập kế hoạch sáng":  a DailyPlan with id === today exists.
 */
export function deriveGettingStarted(state: LifeOsState, today: string): GettingStartedStep[] {
  const hasPlan = state.dailyPlans.some((p) => p.id === today);
  return [
    {
      id: "add-task",
      label: "Ghi việc đầu tiên",
      done: state.tasks.length > 0,
      actionKind: "task",
    },
    {
      id: "add-goal",
      label: "Tạo mục tiêu",
      done: state.goals.length > 0,
      actionKind: "goal",
    },
    {
      id: "morning-plan",
      label: "Lập kế hoạch sáng",
      done: hasPlan,
      actionKind: "morning-plan",
    },
  ];
}

/** Returns true when all 3 steps are done — checklist should auto-hide. */
export function isGettingStartedAllDone(steps: GettingStartedStep[]): boolean {
  return steps.every((s) => s.done);
}
